import React from 'react'
import { Link } from 'gatsby'
import { social } from '../data/siteData'
import { confirmRedirectOnClick } from '../helper/utils'
// import { Facebook, Twitter } from '@icons-pack/react-simple-icons'

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footerWrap baseWrap">
				<div className="footerCategory">
					<h3>Other Links</h3>
					<ul className="footer_links">
						<li><Link to={`/grievance/`} className="link">Grievance</Link></li>
						<li><Link to={`/online/kalyan-mandap/`} className="link">Kalyan Mandap Reservation</Link></li>
						<li><Link to={`/online/cesspool-vehicle/`} className="link">Cesspool Vehicle</Link></li>
						{/* <li><a href="#!" className="link">Sitemap</a></li> */}
						{/* <li><a href="#!" className="link">Terms and Conditions</a></li>
						<li><a href="#!" className="link">Privacy Policy</a></li> */}
					</ul>
				</div>
				<div className="footerCategory">
					<h3>Office Address</h3>
					<div className="iconDisplay">
						<i className="material-icons-round">place</i>
						<address>Notified Area Council,<br />Dharamgarh, Kalahandi,<br />Odisha - 766015 <br />India</address>
					</div>
					{/* <div className="iconDisplay">
						<i className="material-icons-round">phone_in_talk</i>
						<a href="tel:#" className="link">+91-1234567890</a>
					</div> */}
					{/* <div className="iconDisplay">
						<i className="material-icons-round">mail_outline</i>
						<a href="mailto:#" className="link">info@example.com</a>
					</div> */}
					<div className="social df jcc aic">
						<a href={social.facebook} className="link" title="Facebook Handle" onClick={confirmRedirectOnClick}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								fill="none"
								stroke="currentColor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								className="social_icon"
								viewBox="0 0 24 24"
							>
								<path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
							</svg>
						</a>
						<a href={social.twitter} className="link" title="Twitter Handle" onClick={confirmRedirectOnClick}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								fill="none"
								stroke="currentColor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								className="social_icon"
								viewBox="0 0 24 24"
							>
								<path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
